import { Box, Paper, Stack, Typography } from "@mui/material";
import type { LucideIcon } from "lucide-react";
import type { FC, ReactNode } from "react";

export interface FormSectionProps {
  title: string;
  description: string;
  Icon: LucideIcon;
  children: ReactNode;
}

const FormSection: FC<FormSectionProps> = ({
  title,
  description,
  Icon,
  children,
}) => {
  return (
    <Paper
      variant="outlined"
      sx={{
        p: 2.5,
        borderRadius: 2,
        borderColor: "brandBorder.primary",
        backgroundColor: "background.paper",
      }}
    >
      <Stack direction="row" alignItems="flex-start" spacing={2} mb={2}>
        <Stack
          alignItems="center"
          justifyContent="center"
          sx={{
            width: 40,
            height: 40,
            flexShrink: 0,
            bgcolor: "grey.50",
            borderRadius: 2,
            border: "1px solid",
            borderColor: "divider",
          }}
        >
          <Icon size={22} color="#8D8D8D" />
        </Stack>
        <Stack direction="column" flex={1} minWidth={0}>
          <Typography variant="headingXS" fontWeight={600} lineHeight={1.4}>
            {title}
          </Typography>
          <Typography
            variant="textSM"
            color="brandText.secondary"
            lineHeight={1.5}
            sx={{ mt: 0.5 }}
          >
            {description}
          </Typography>
        </Stack>
      </Stack>
      <Stack spacing={2}>
        <Box>{children}</Box>
      </Stack>
    </Paper>
  );
};

export default FormSection;
